import charting from './charting.component';

export default angular
  .module('st.Integrations.Charting', [])
  .component('charting', charting)
  .service('chartingService', ($http, dataService, CHARTING) => ({
    create: (params) =>
      dataService.apiRequest(null, null, true, null, $http.post, CHARTING.API.CREATE, params)
  }))
  .constant('CHARTING', {
    API: {
      CREATE: '/api/v1/integration/charting/'
    }
  });
